/* Tidilo single-frame angles. Manual browsing remains still until Play is chosen. */
(() => {
  function init(root = document) {
    const galleries = [...root.querySelectorAll('[data-angle-gallery]')];
    if (root.matches?.('[data-angle-gallery]')) galleries.unshift(root);
    galleries.forEach(gallery => {
      if (gallery.dataset.angleReady) return;
      gallery.dataset.angleReady = 'true';
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const controls = gallery.querySelector('[data-gallery-controls]');
      const counter = gallery.querySelector('[data-gallery-counter]');
      const pause = gallery.querySelector('[data-gallery-pause]');
      const error = gallery.querySelector('[data-gallery-error]');
      const announcement = gallery.querySelector('[data-gallery-announcement]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, playing = !motion.matches, hovering = false, focused = false, timer;
      const stop = () => { clearInterval(timer); timer = null; };
      const schedule = () => {
        stop();
        if (pause) pause.textContent = playing ? 'Pause slideshow' : 'Play slideshow';
        if (slides.length > 1 && playing && !hovering && !focused && !document.hidden && gallery.isConnected) {
          timer = setInterval(() => { if (!gallery.isConnected) stop(); else show(index + 1); }, 7000);
        }
      };
      const show = (next, manual = false) => {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        const img = slides[index].querySelector('img');
        if (img) img.loading = 'eager';
        if (error) error.hidden = slides[index].dataset.failed !== 'true';
        if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
        if (manual) {
          playing = false;
          if (announcement) announcement.textContent = `Photo ${index + 1} of ${slides.length}. ${img?.alt || ''}`;
          schedule();
        }
      };
      if (controls) controls.hidden = slides.length < 2;
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1, true));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1, true));
      pause?.addEventListener('click', () => { playing = !playing; schedule(); });
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      gallery.addEventListener('pointerenter', () => { hovering = true; schedule(); });
      gallery.addEventListener('pointerleave', () => { hovering = false; schedule(); });
      gallery.addEventListener('focusin', () => { focused = true; schedule(); });
      gallery.addEventListener('focusout', event => { if (!gallery.contains(event.relatedTarget)) { focused = false; schedule(); } });
      document.addEventListener('visibilitychange', schedule);
      motion.addEventListener('change', event => { if (event.matches) playing = false; schedule(); });
      slides.forEach(slide => {
        const img = slide.querySelector('img');
        const failed = () => { slide.dataset.failed = 'true'; if (slide === slides[index] && error) error.hidden = false; };
        img?.addEventListener('error', failed);
        img?.addEventListener('load', () => { delete slide.dataset.failed; if (slide === slides[index] && error) error.hidden = true; });
        if (img?.complete && !img.naturalWidth) failed();
      });
      const variantSelect = gallery.closest('.pdp')?.querySelector('select[name="id"]');
      const selectedImage = () => variantSelect?.selectedOptions[0]?.dataset.galleryImage;
      let colourImage = selectedImage();
      variantSelect?.addEventListener('change', () => {
        const id = selectedImage();
        // A size-only change must not reset a manually browsed colour detail.
        const changed = id !== colourImage;
        colourImage = id;
        const target = slides.findIndex(slide => slide.dataset.imageId === id);
        if (changed && target >= 0) show(target, true);
      });
      const initial = slides.findIndex(slide => slide.dataset.imageId === colourImage);
      show(initial >= 0 ? initial : 0); schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
